import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import Loading from "../UI/Loading";

const tipos = (tdp) =>
  [
    tdp.eEletiva && { label: "Eletiva", color: "secondary" },
    tdp.eProjeto && { label: "Projeto", color: "info" },
    tdp.escolhaAluno && {
      label: tdp.capacidadeMaxima ? `Escolha do aluno · ${tdp.capacidadeMaxima} vagas` : "Escolha do aluno",
      color: "success",
    },
  ].filter(Boolean);

/** Disciplinas cadastradas na turma. */
export default function DisciplinaTurmaTable({
  tdps,
  isLoading,
  registrando,
  podeRemover,
  onEdit,
  onRegister,
  onDelete,
}) {
  if (isLoading) {
    return (
      <Box py={6}>
        <Loading description="Carregando disciplinas da turma..." />
      </Box>
    );
  }

  if (tdps.length === 0) {
    return (
      <Box
        sx={{
          py: 6,
          textAlign: "center",
          color: "text.secondary",
          border: 1,
          borderStyle: "dashed",
          borderColor: "divider",
          borderRadius: 2,
        }}
      >
        <MenuBookOutlinedIcon fontSize="large" />
        <Typography variant="body2" mt={1}>
          Nenhuma disciplina cadastrada nesta turma.
        </Typography>
      </Box>
    );
  }

  return (
    <TableContainer sx={{ border: 1, borderColor: "divider", borderRadius: 2 }}>
      <Table size="small" aria-label="Disciplinas da turma">
        <TableHead>
          <TableRow sx={{ "& th": { fontWeight: 600, bgcolor: "action.hover" } }}>
            <TableCell>Disciplina</TableCell>
            <TableCell>Professor</TableCell>
            <TableCell>Livro</TableCell>
            <TableCell>Carga horária</TableCell>
            <TableCell align="right" sx={{ width: 136 }} />
          </TableRow>
        </TableHead>
        <TableBody>
          {tdps.map((tdp) => (
            <TableRow key={tdp.codigo ?? tdp.disciplina?.codDisciplina} hover>
              <TableCell>
                <Typography variant="body2" fontWeight={500}>
                  {tdp.disciplina?.descricao}
                </Typography>
                {tipos(tdp).length > 0 && (
                  <Stack direction="row" spacing={0.5} mt={0.5} useFlexGap flexWrap="wrap">
                    {tipos(tdp).map((t) => (
                      <Chip key={t.label} size="small" variant="outlined" color={t.color} label={t.label} />
                    ))}
                  </Stack>
                )}
              </TableCell>
              <TableCell sx={{ color: tdp.usuario ? "text.primary" : "text.disabled" }}>
                {tdp.usuario?.nome ?? "Sem professor"}
              </TableCell>
              <TableCell sx={{ color: tdp.livro ? "text.primary" : "text.disabled" }}>
                {tdp.livro?.descricao ?? "--"}
              </TableCell>
              <TableCell>{tdp.cargaHoraria || "--"}</TableCell>
              <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                <Tooltip title="Editar">
                  <IconButton size="small" onClick={() => onEdit(tdp)}>
                    <EditOutlinedIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Registrar nota bimestre / conceito aluno">
                  <span>
                    <IconButton size="small" disabled={registrando !== null} onClick={() => onRegister(tdp)}>
                      {registrando === tdp.codigo ? (
                        <CircularProgress size={18} />
                      ) : (
                        <PlaylistAddCheckIcon fontSize="small" />
                      )}
                    </IconButton>
                  </span>
                </Tooltip>
                {podeRemover && (
                  <Tooltip title="Remover da turma">
                    <IconButton size="small" onClick={() => onDelete(tdp)}>
                      <DeleteOutlineIcon fontSize="small" color="error" />
                    </IconButton>
                  </Tooltip>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
